import enviro from 'enviro';
import { getIsQAProxy } from 'pricing-pages-lib/utils/proxyUtils';
import { getPublicSiteDomain } from 'pricing-pages-lib/utils/publicPageUrls';
import getLocale from 'pricing-pages-ui/utils/getLocale';
import { useEffect, useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
// This component exists so we can code split the react-nav
const BaseLayout = ({
  children,
  isLoggedIn,
  pathname
}) => {
  const [marketingScriptLoaded, setMarketingScriptLoaded] = useState(false);

  // substring to remove stuff like -br from pt-br
  const locale = getLocale().substring(0, 2);
  const isQA = enviro.isQa() || getIsQAProxy();
  const MARKETING_SCRIPT_ID = 'marketing-nav-script';
  const MARKETING_HEADER_ID = 'marketing-header';
  const MARKETING_FOOTER_ID = 'marketing-footer';
  const onScriptLoad = () => {
    setMarketingScriptLoaded(true);
  };
  useEffect(() => {
    let marketingScript = document.getElementById(MARKETING_SCRIPT_ID);
    if (!marketingScript) {
      // Loads in the marketing nav script from CDN
      marketingScript = document.createElement('script');
      marketingScript.async = true;
      marketingScript.src = isQA ? 'https://www.hubspot.com/assets/nav/next/index.js' : 'https://www.hubspot.com/assets/nav/latest/index.js';
      marketingScript.id = MARKETING_SCRIPT_ID;
      document.body.appendChild(marketingScript);
    }
    marketingScript.addEventListener('load', onScriptLoad);
    if (marketingScriptLoaded) {
      const defaultContentBlob = window.marketingNav.getNavContentBlob({
        type: 'header',
        locale
      });
      const domain = getPublicSiteDomain();
      const domainWithoutHttps = domain.replace(/^https:\/\//, '');
      const computedContentBlob = Object.assign({}, defaultContentBlob, {
        navCta: Object.assign({}, defaultContentBlob.navCta, {
          navCtaUrl: `${domain}/products/get-started?hubs_content=${domainWithoutHttps}/pricing${pathname}&hubs_content-cta=homepage-nav`
        })
      });

      //renders header
      window.marketingNav.renderNav({
        type: 'header',
        locale,
        targetId: MARKETING_HEADER_ID,
        isLoggedIn,
        variation: 'default',
        contentBlob: computedContentBlob
      });

      // renders footer
      window.marketingNav.renderNav({
        type: 'footer',
        locale,
        targetId: MARKETING_FOOTER_ID
      });
    }
    return () => {
      marketingScript.removeEventListener('load', onScriptLoad);
      marketingScript.remove();
    };
  }, [isLoggedIn, isQA, locale, marketingScriptLoaded, pathname]);

  // Due to slight delay, this is to render entire page once script is loaded
  if (!marketingScriptLoaded) return null;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("header", {
      id: MARKETING_HEADER_ID
    }), children, /*#__PURE__*/_jsx("footer", {
      id: MARKETING_FOOTER_ID
    })]
  });
};
export default BaseLayout;